import React from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';

// Custom HOC to replace withRouter in React Router v6
export function withRouter(Component) {
  function ComponentWithRouterProps(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    // Create a history-like object for backward compatibility
    const history = {
      push: navigate,
      replace: (path) => navigate(path, { replace: true }),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      go: (n) => navigate(n),
      location
    };

    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
        history={history}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
    );
  }

  // Set display name for debugging
  const displayName = Component.displayName || Component.name || 'Component';
  ComponentWithRouterProps.displayName = `withRouter(${displayName})`;

  return ComponentWithRouterProps;
}
